import styled from "styled-components";

export const FooterContainer = styled.footer`
  text-align: center;
  padding: 30px 0;

  p {
    font-size: 14px;
  }
`;
